import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const SuccessScreen = ({ onClose, isEdit = false, isResubmit = false }) => {
  const theme  = useTheme();
  const t      = theme.custom;

  const title   = isResubmit ? "Request Resubmitted"
                : isEdit     ? "Changes Saved"
                :              "Request Submitted";

  const body    = isResubmit
    ? "Your request has been resubmitted to PMO for review. A new request code has been assigned. Track progress in Status Flow."
    : isEdit
    ? "Your allocation request has been updated."
    : "Your allocation request has been sent to PMO for review. Track progress in Status Flow.";

  return (
    <Box sx={{
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      flex: 1, padding: "40px 24px", textAlign: "center",
    }}>
      {/* Check circle */}
      <Box sx={{
        width: "60px", height: "60px", borderRadius: "50%",
        border: `2px solid ${t.accent}`,
        display: "flex", alignItems: "center", justifyContent: "center",
        mb: "20px",
      }}>
        <Typography sx={{ fontSize: "22px", color: t.accent }}>✓</Typography>
      </Box>

      <Typography sx={{
        fontFamily: "'Inter', sans-serif",
        fontSize: "18px", fontWeight: 700,
        color: t.accent, mb: "10px",
      }}>
        {title}
      </Typography>

      <Typography sx={{
        fontFamily: "'Inter', sans-serif",
        fontSize: "13px", color: t.text2,
        lineHeight: 1.7, maxWidth: "300px",
      }}>
        {body}
      </Typography>

      <Box
        onClick={onClose}
        sx={{
          mt: "28px", padding: "8px 28px",
          border: `1px solid ${t.border2}`,
          borderRadius: "3px", cursor: "pointer",
          fontFamily: "'DM Mono', monospace",
          fontSize: "11px", color: t.text2,
          transition: "all 0.15s",
          "&:hover": { borderColor: t.border3, color: t.text },
        }}
      >
        Close
      </Box>
    </Box>
  );
};

export default SuccessScreen;